import React from "react";
import {
  Table,
  TableContainer,
  TableHead,
  Stack,
  TableCell,
  Divider,
  Tooltip,
  IconButton,
} from "@mui/material";
import { REPORT_TABLE_HEADERS } from "../../constant/TableHeaders";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  StyledTableBody,
  TableBodyRow,
  TableHeaderRow,
} from "../../styles/TableStyles";
import { INDIAN_RUPEE_SIGN } from "../../constant/constant";

const ReportTable = ({ rows }) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableHeaderRow>
            {REPORT_TABLE_HEADERS.map((item, index) => (
              <TableCell
                key={index}
                align={item.alignItemTo}
                sx={{ width: item.width }}
              >
                {item.title}
              </TableCell>
            ))}
          </TableHeaderRow>
        </TableHead>

        <StyledTableBody>
          {rows.map((row, index) => (
            <TableBodyRow
              key={row.id || `${row.month}-${index}`}
              hover
              sx={{
                "&:hover": {
                  backgroundColor: "#f9f9f9",
                },
              }}
            >
              <TableCell sx={{ width: 400, alignItemTo: "left" }}>
                {row.month}
              </TableCell>
              <TableCell sx={{ width: 400, alignItemTo: "left" }}>
                {`${INDIAN_RUPEE_SIGN} ${row.totalRent}`}
              </TableCell>
              <TableCell sx={{ width: 400, alignItemTo: "left" }}>
                {`${INDIAN_RUPEE_SIGN} ${row.paidAmount}`}
              </TableCell>
              <TableCell sx={{ width: 400, alignItemTo: "left" }}>
                {`${INDIAN_RUPEE_SIGN} ${row.overdueAmount}`}
              </TableCell>
              <TableCell sx={{ width: 100, alignItemTo: "left" }}>
                <Stack
                  direction="row"
                  spacing={1}
                  divider={<Divider orientation="vertical" flexItem />}
                >
                  <Tooltip title="View" arrow>
                    <IconButton
                      //onClick={() => handleViewClick(row)}
                      size="small"
                    >
                      <VisibilityOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Edit" arrow>
                    <IconButton
                    //</Tooltip>onClick={() => handleEdit(row.id)} size="small"
                    >
                      <EditOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete" arrow>
                    <IconButton
                      //onClick={() => handleDeleteClick(row.id)}
                      size="small"
                    >
                      <DeleteOutlineOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </TableCell>
            </TableBodyRow>
          ))}
        </StyledTableBody>
      </Table>
    </TableContainer>
  );
};

export default ReportTable;
